import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, SECTION_STYLE_FIELDS } from './_fields'

/** A swipe row of tint cards: rating, quote, photo, name and role. */
export const schema: ComponentSchema = {
  type: 'testimonials',
  label: 'Testimonials',
  description: 'Customer quotes as review cards with rating, photo, name and role.',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Review cards' },
  ],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'What customers say' },
    {
      key: 'items',
      label: 'Reviews',
      type: 'array',
      itemSchema: [
        { key: 'avatar', label: 'Photo', type: 'image' },
        { key: 'name', label: 'Name', type: 'string' },
        { key: 'designation', label: 'Role or city', type: 'string' },
        { key: 'review', label: 'Review', type: 'text' },
        { key: 'rating', label: 'Rating (1–5)', type: 'number', default: 5 },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
}
